import AgedAccountsPayablesSection from "./AgedAccountsPayablesSection.js";
import AgedAccountsReceivablesSection from "./AgedAccountsReceivablesSection.js";
import AttachmentSection from "./AttachmentSection.js";
import BalanceSheetSection from "./BalanceSheetSection.js";
import BusinessOverviewSection from "./BusinessOverviewSection.js";
import IncomeStatementSection from "./IncomeStatementSection.js";
import KeyfigureSection from "./KeyfigureSection.js";
import ModelFactory from "../../../ModelFactory.js";

/**
 * `PeriodReportSectionFactory` instantiates the correct period report section class depending on the
 * period report section type.
 */
class PeriodReportSectionFactory extends ModelFactory {
	allClasses() {
		return [
			BusinessOverviewSection,
			IncomeStatementSection,
			BalanceSheetSection,
			KeyfigureSection,
			AgedAccountsReceivablesSection,
			AgedAccountsPayablesSection,
			AttachmentSection,
		];
	}

	defaultSections(wantsAgedInvoices = false) {
		return this.allClasses()
			.filter(
				(SectionClass) =>
					wantsAgedInvoices || !SectionClass.isAgedAccountsSection(),
			)
			.map((SectionClass) => new SectionClass());
	}

	newFromExisting(section) {
		return new section.constructor({
			enabled: section.isEnabled(),
			comment: section.getComment(),
		});
	}
}

const periodReportSectionFactory = new PeriodReportSectionFactory();

export default periodReportSectionFactory;
